import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgMagnifyingGlass = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m20.725 19.559-4.711-4.711c1.02-1.248 1.582-2.82 1.582-4.536A7.31 7.31 0 0 0 10.283 3c-4.038 0-7.28 3.274-7.28 7.313s3.273 7.312 7.28 7.312a7.27 7.27 0 0 0 4.536-1.583l4.71 4.71a.97.97 0 0 0 .63.248.84.84 0 0 0 .596-.247.82.82 0 0 0-.03-1.194M4.69 10.312a5.63 5.63 0 0 1 5.625-5.624 5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.624 5.63 5.63 0 0 1-5.625-5.624"
    }));
export default SvgMagnifyingGlass;
